import { render, staticRenderFns } from "./Relation.vue?vue&type=template&id=3cb350ec&scoped=true"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"
import style0 from "./Relation.vue?vue&type=style&index=0&id=3cb350ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb350ec",
  null
  
)

export default component.exports